import { useEffect, useState } from "react";
import { FileDown } from "lucide-react";
import { api, API } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const TutorialsDialog = ({ open, onClose }) => {
  const [list, setList] = useState(null);
  useEffect(() => {
    if (open && !list) api.get("/tutorials").then((r) => setList(r.data)).catch(() => setList([]));
  }, [open, list]);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="tutorials-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Tutorial</DialogTitle>
          <DialogDescription>Guide in PDF per il tuo ruolo e reparto, da scaricare, stampare o inoltrare.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-2">
          {(list || []).map((t) => (
            <a key={t.key} href={`${API}/tutorials/${t.key}.pdf`} className="flex items-center gap-3 border p-3 transition-colors hover:bg-muted" data-testid={`tutorial-download-${t.key}`}>
              <FileDown className="h-5 w-5 shrink-0 text-primary" />
              <div><div className="text-sm font-semibold">{t.title}</div><div className="text-xs text-muted-foreground">{t.subtitle}</div></div>
            </a>
          ))}
          {list && !list.length && <p className="text-sm text-muted-foreground">Nessun tutorial disponibile.</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
